export const BACKSOLVE_SUMMARY_TITLE = 'Backsolve Summary';
export const IMPLIED_EQUITY_VALUE_TITLE = 'Implied Equity Value';
export const ENTERPISE_VALUE_TITLE = 'Enterprise Value';
export const IMPLIED_EQUITY_VALUE_ALIAS = 'implied_equity_value';
export const SUMMARY_ENTERPRISE_VALUE_ALIAS = 'summary_enterprise_value';
